import { Illustration } from "@storeblocks/icon";
import { StbH1 } from "App/global-style";
import styled from "styled-components";

export const StyledIllustration = styled(Illustration)`
  margin: 0 90px;
`;

export const StyledStbH1 = styled(StbH1)`
  margin-bottom: 24px;
`;
